<template>
  <div
    class="d-none d-lg-block _ps-fixed _qr-line-image"
    :style="`transform: translateX(${translateX}px)`">
    <img
      :src="qrImageSrc"
      alt="QR Line Image"
      width="350"
      loading="lazy">
    <div
      class="qr-button"
      :style="`left: ${buttonLeft}px;`"
      @click="toggleQR()">
      <v-icon
        v-if="!isQRHidden"
        color="white">
        mdi-menu-right
      </v-icon>
      <v-icon
        v-else
        color="white">
        mdi-menu-left
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      translateX: 325,
      buttonLeft: 25,
      qrImageSrc: '/img/qr-line.png'
    }
  },
  computed: {
    isQRHidden: {
      get () {
        return this.$store.getters['QRCodePopup/isShowQR']
      },
      set (val) {
        this.$store.dispatch('QRCodePopup/setShowQR', val)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.isQRHidden) {
        this.qrImageSrc = '/img/hide-qr-line.png'
        this.translateX = 210
        this.buttonLeft = 116
      } else {
        this.qrImageSrc = '/img/qr-line.png'
        this.translateX = 60
        this.buttonLeft = 25
      }
    }, 200)
  },
  methods: {
    toggleQR () {
      this.translateX = 325

      if (!this.isQRHidden) {
        setTimeout(() => {
          this.isQRHidden = true
          this.qrImageSrc = '/img/hide-qr-line.png'
          this.translateX = 210
          this.buttonLeft = 116
        }, 500)
      } else {
        setTimeout(() => {
          this.isQRHidden = false
          this.qrImageSrc = '/img/qr-line.png'
          this.translateX = 60
          this.buttonLeft = 25
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
._qr-line-image {
  right: 0;
  top: 0;
  z-index: 2;
  transition-duration: .5s;
}
.qr-button {
  position: absolute;
  top: 60px;
  z-index: 3;

  background-color: #373737;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  width: fit-content;

  cursor: pointer;
  transition-duration: .3s;
}
.qr-button:hover {
  background-color: #444444;
}
</style>
